import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const SecurityBanner = () => {
  const { t } = useTranslation();
  return (
    <section>
      <div className="security-banner-warp">
        <div className="security-banner">
          <div className="banner-bg">
            <img src={`//files.authing.co/authing-website/banner-security.svg`} alt="authing security banner" />
          </div>
          <div className="banner-content">
            <div className="banner-title">{t("security.Authing安全与合规")}</div>
            <div className="banner-subtitle">{t("security.security-banner-subtitle")}</div>
          </div>
        </div>
      </div>
    </section>
  );
};
